import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import el from '@/locales/el.json'
import ptBR from '@/locales/pt-BR.json'
import es from '@/locales/es.json'

type MessageSchema = typeof en

// pt-BR and es are loaded but the LoginView picker is intentionally
// NOT exposing them yet -- soft release. The locale files exist so a
// pre-release tester can flip via localStorage / URL, the agronomist
// review (docs/i18n_agronomist_review.md) can run against the actual
// runtime, and tests can validate parity. The picker buttons land
// after the human review pass signs off.
export type AppLocale = 'en' | 'el' | 'pt-BR' | 'es'
const SUPPORTED_LOCALES: readonly AppLocale[] = ['en', 'el', 'pt-BR', 'es']

function getStoredLanguage(): AppLocale {
  const stored = localStorage.getItem('agroptimizer_lang')
  if (stored && (SUPPORTED_LOCALES as readonly string[]).includes(stored)) {
    return stored as AppLocale
  }
  return 'en'
}

const i18n = createI18n<[MessageSchema], AppLocale>({
  legacy: false,
  locale: getStoredLanguage(),
  fallbackLocale: 'en',
  messages: { en, el, 'pt-BR': ptBR, es },
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
})

document.documentElement.lang = (i18n.global.locale as unknown as { value: AppLocale }).value

export default i18n

export function setLocale(lang: AppLocale) {
  ;(i18n.global.locale as unknown as { value: string }).value = lang
  localStorage.setItem('agroptimizer_lang', lang)
  document.documentElement.lang = lang
}

export function getCurrentLocale(): string {
  const loc = (i18n.global.locale as unknown as { value: string }).value
  if (loc === 'el') return 'el-GR'
  if (loc === 'pt-BR') return 'pt-BR'
  if (loc === 'es') return 'es-419'
  return 'en-US'
}
